// extracted by mini-css-extract-plugin
module.exports = {"brand":"style-module--brand--2Qhce","navWrapper":"style-module--navWrapper--1KGyE"};